import React from 'react';
import { i18nFn, useSpringBigStore } from '@springbig/shared';
import { VStack, Box } from 'native-base';
import { Caption, H3 } from '~/shared/Typography';
import Button from '~/shared/Button';
import { useGeneralStyles } from '~/shared/styles';
import { useLocation } from 'react-router';
import { AuthTemplate } from '~/pages/auth/AuthTemplate';

type WelcomeStepProps = {
    t: i18nFn;
    onEvent: (message: string) => void;
};

export const WelcomeStep = ({
    t,
    onEvent,
}: WelcomeStepProps) => {

    const location = useLocation();
    const gStyle = useGeneralStyles();
    const { member } = useSpringBigStore();

    const handleViewMessage = (): void => {
        onEvent('messages');
    };

    const WelcomeBody = () => {
        return <VStack space={8} w={"100%"} alignItems={"center"}>
            <VStack w={"100%"}>
                <H3 fontSize={20}>
                    {member?.first_name
                        ? t("ten_dlc.welcome.title", [member.first_name])
                        : t("ten_dlc.welcome.title_anonymous")}
                </H3>
                <Caption maxW={"100%"}>
                    {t("ten_dlc.welcome.description")}
                </Caption>
            </VStack>
            <VStack w="100%" space={4} alignItems="center">
                <Box position="relative" w="100%" alignItems="center">
                    <Button
                        bg={gStyle.button_background}
                        w={"100%"}
                        _text={{ color: "white" }}
                        onPress={handleViewMessage}
                        borderRadius={"12px"}
                    >
                        {t("ten_dlc.welcome.view_message")}
                    </Button>
                    <Box
                        position="absolute"
                        top={-4}
                        right={-4}
                        bg="red"
                        w={4}
                        h={4}
                        borderRadius="full"
                        borderWidth={2}
                        borderColor="white"
                    />
                </Box>
            </VStack>
        </VStack>;
    };

    if (location.pathname.includes('tendlc')) {
        return (
            <AuthTemplate
                body={<WelcomeBody />}
            />
        );    
    }

    return <WelcomeBody />;
};
